<template>
  <div class="panel__phrase-wrapper">
    <span
      v-for="(word, index) in words"
      :key="index"
      class="panel__partial-phrase"
    >
      <template v-if="word.isMisspelled">
        <span class="misspelled-word">{{ word.text }}</span>
        <!-- <strong class="ml-1">{{ word.correction }}</strong> -->
      </template>
      <span v-else>{{ word.text }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    words: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.panel__phrase-wrapper {
  @apply flex max-w-full flex-wrap;
  .panel__partial-phrase:not(:first-child):not(:last-child) {
    @apply ml-1;
  }
  .misspelled-word {
    @apply font-bold;
    color: #B82A33;
  }
}
</style>
